var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.654783 5.80186L5.74261 10.8756C5.90931 11.0417 6.17919 11.0415 6.34561 10.8747C6.5119 10.7081 6.51147 10.438 6.34475 10.2717L1.55977 5.49998L6.34492 0.72824C6.51162 0.561952 6.51205 0.292088 6.34578 0.125369C6.26236 0.0417957 6.15307 7.60167e-06 6.04378 7.59211e-06C5.93477 7.58258e-06 5.82591 0.0415162 5.74263 0.12451L0.654783 5.19813C0.574496 5.27801 0.529443 5.38672 0.529443 5.49998C0.529443 5.61325 0.574625 5.72183 0.654783 5.80186Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.1808deea3c5e7f21fb54b3cb42a3eeee.svg";
export { ForwardRef as ReactComponent };